
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface DescriptionSectionProps {
  formData: {
    missionStatement: string;
    companyDescription: string;
  };
  onChange: (key: string, value: string) => void;
  isLoading: boolean;
}

export function DescriptionSection({ formData, onChange, isLoading }: DescriptionSectionProps) {
  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="mission">Mission Statement</Label>
        <Textarea
          id="mission"
          placeholder="Enter your organization's mission"
          value={formData.missionStatement}
          onChange={(e) => onChange("missionStatement", e.target.value)}
          disabled={isLoading}
          className="h-24 mt-1.5"
        />
      </div>

      <div>
        <Label htmlFor="description">Organization Description</Label>
        <Textarea
          id="description"
          placeholder="What does your organization do?"
          value={formData.companyDescription}
          onChange={(e) => onChange("companyDescription", e.target.value)}
          disabled={isLoading}
          className="h-24 mt-1.5"
        />
      </div>
    </div>
  );
}
